import React from 'react';
import BuyButton from './BuyButton';
import { translate } from '../../Services/translation';
import ProductSampleItem from '../../Types/ProductSampleItem';
import useIsStoreScreen from '../../Hooks/useIsStoreScreen';

interface BuySampleButtonProps
  extends ProductSampleItem,
    React.ButtonHTMLAttributes<HTMLButtonElement> {
  styleClassName?: string;
  btnSize?: 'medium' | 'large';
}

const BuySampleButton = ({
  articleNumber,
  formattedPrice,
  styleClassName,
  btnSize,
  ...buttonProps
}: BuySampleButtonProps) => {
  const isStoreScreen = useIsStoreScreen();

  return (
    <>
      <BuyButton
        articleNumber={articleNumber}
        btnSize={btnSize}
        label={translate('product-page.buy-sample').replace(
          '{PRICE}',
          formattedPrice ?? ''
        )}
        styleClassName={styleClassName ?? 'btn--white'}
        {...buttonProps}
      />
    </>
  );
};

export default BuySampleButton;
